// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vMf74","left":"styles_left__1Z513"};